import { defineMessages } from "react-intl";
const messages = defineMessages({
    // Form General
    addNewRequestButton: {
        id: "app.scanRequests.table.button.newRequest",
        defaultMessage: "Add New Request",
    },
    addNewRequestButtonPolicyAlert: {
        id: "app.scanRequests.table.button.newRequest.policyAlert",
        defaultMessage: "You are not permitted to create a scan request",
    },
    addNewRequestDialog: {
        id: "app.scanRequests.table.dialog.newRequest",
        defaultMessage: "Request A Scan",
    },
    addNewRequestDialogSubmit: {
        id: "app.scanRequests.table.dialog.newRequest.submitButton",
        defaultMessage: "Submit Form",
    },
    // Form Messages
    addNewRequestCommunityLabel: {
        id: "app.scanRequests.table.newRequest.label.community",
        defaultMessage: "Select a Community",
    },
    addNewRequestCommunityPlaceholder: {
        id: "app.scanRequests.table.newRequest.placeholder.community",
        defaultMessage: "Community",
    },
    addNewRequestSpaceTypePlaceholder: {
        id: "app.scanRequests.table.newRequest.placeholder.spaceType",
        defaultMessage: "Add: ",
    },
    addNewRequestEarliestDateLabel: {
        id: "app.scanRequests.table.newRequest.label.earliestDate",
        defaultMessage: "When is the earliest we can begin?",
    },
    addNewRequestEarliestDatePlaceholder: {
        id: "app.scanRequests.table.newRequest.placeholder.earliestDate",
        defaultMessage: "mm/dd/yy",
    },
    addNewScheduledForDateLabel: {
        id: "app.scanRequests.table.scheduledFor.label.earliestDate",
        defaultMessage: "When is the scan scheduled for?",
    },
    addNewScheduledForDatePlaceholder: {
        id: "app.scanRequests.table.scheduledFor.placeholder.earliestDate",
        defaultMessage: "mm/dd/yy",
    },
    addNewScheduledScannerEmailLabel: {
        id: "app.scanRequests.table.scannerEmail.label",
        defaultMessage: "Scanner's Email",
    },
    addNewScheduledScannerEmailPlaceholder: {
        id: "app.scanRequests.table.scannerEmail.placeholder",
        defaultMessage: "Select or Type a Scanner's Email",
    },
    addNewRequestAccessDetailsLabel: {
        id: "app.scanRequests.table.newRequest.label.accessDetails",
        defaultMessage: "Access Details",
    },
    addNewRequestAccessDetailsPlaceholder: {
        id: "app.scanRequests.table.newRequest.placeholder.accessDetails",
        defaultMessage: "Details",
    },
    addNewRequestAccessDetailsSpecifyPlaceholder: {
        id: "app.scanRequests.table.newRequest.placeholder.accessDetailsSpecify",
        defaultMessage: "Please Specify",
    },
    addNewRequestAccessSpecialInstructionsLabel: {
        id: "app.scanRequests.table.newRequest.label.specialInstructions",
        defaultMessage: "Special Instructions",
    },
    addNewRequestAccessSpecialInstructionsPlaceholder: {
        id: "app.scanRequests.table.newRequest.placeholder.specialInstructions",
        defaultMessage: "Please let our team know any extra information our scanners will need to have a successful shoot.\n\nEx. 'Scanner will be required to wear a hard hat that they can get from the leasing office.'",
    },
    addNewRequestAccessSearchSpacesLabel: {
        id: "app.scanRequests.table.newRequest.label.searchSpaces",
        defaultMessage: "Search and add a Space to Scan",
    },
    addNewRequestAccessSearchSpacesPlaceholder: {
        id: "app.scanRequests.table.newRequest.label.searchSpaces",
        defaultMessage: "Search the desired Unit or Amenity",
    },
    addNewRequestTimeWindowLabel: {
        id: "app.scanRequest.table.schedule.timeWindow.label",
        defaultMessage: "Add Time Window",
    },
    // Confirm Close Form Messages
    addNewRequestCloseTitle: {
        id: "app.scanRequests.table.newRequest.close.title",
        defaultMessage: "Are you sure you want to leave?",
    },
    addNewRequestCloseSubtitle: {
        id: "app.scanRequests.table.newRequest.close.subtitle",
        defaultMessage: "Leaving this request form will delete any progress on it.",
    },
    addNewRequestCloseBack: {
        id: "app.scanRequests.table.newRequest.close.back.label",
        defaultMessage: "No, continue request",
    },
    addNewRequestCloseConfirm: {
        id: "app.scanRequests.table.newRequest.close.confirm.label",
        defaultMessage: "Yes, cancel request",
    },
    // Form Errors
    addNewRequestAccessCommunityError: {
        id: "app.scanRequests.table.newRequest.community.error",
        defaultMessage: "Community is required",
    },
    addNewRequestAccessSpaceTypeError: {
        id: "app.scanRequests.table.newRequest.spaceType.error",
        defaultMessage: "Space Type is required",
    },
    addNewRequestAccessSpaceCountError: {
        id: "app.scanRequests.table.newRequest.spaceCount.error",
        defaultMessage: "Select at least one Space",
    },
    addNewRequestAccessEarliestDateError: {
        id: "app.scanRequests.table.newRequest.earliestDate.error",
        defaultMessage: "Earliest Date is required",
    },
    addNewRequestAccessEarliestDateFormatError: {
        id: "app.scanRequests.table.newRequest.earliestDateFormat.error",
        defaultMessage: "Date format is invalid. Follow mm/dd/yy",
    },
    addNewRequestAccessAccessDetailsError: {
        id: "app.scanRequests.table.newRequest.accessDetails.error",
        defaultMessage: "Earliest Date is required",
    },
    addNewRequestAccessScannerEmailError: {
        id: "app.scanRequests.table.newRequest.scannerEmail.error",
        defaultMessage: "Email is not valid",
    },
    addNewRequestAccessAccessDetailsSpecificationError: {
        id: "app.scanRequests.table.newRequest.accessDetailsSpecification.error",
        defaultMessage: "Access Details are required",
    },
    // Notification
    addNewRequestSuccessNotification: {
        id: "app.scanRequests.table.newRequest.notification.success",
        defaultMessage: "Scan Request successfully created",
    },
    addNewRequestSuccessEmail: {
        id: "app.scanRequests.table.newRequest.notification.email",
        defaultMessage: "Scan Request(s) successfully created, scheduled, and notified by email.",
    },
});
export default messages;
